import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { resultsGrid } from '@/mocks/results';

export default function ResultsGrid() {
  const [active, setActive] = useState<number | null>(null);

  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Selected Client Wins
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Real Businesses. Measurable Outcomes.
          </h2>
          <p className="mt-4 text-foreground-600">
            A selection of results and improvements from businesses Josh has
            worked with.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {resultsGrid.map((c, i) => {
            const isOpen = active === i;
            return (
              <Reveal key={c.title} delay={(i % 3) * 80}>
                <div className="flex h-full flex-col rounded-2xl border border-white/8 bg-background-100 p-7 hover:border-primary-500/30 transition-colors">
                  <div className="flex items-center justify-between">
                    <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 text-accent-400 px-3 py-1 text-xs font-label font-semibold">
                      {c.industry}
                    </span>
                    <button
                      onClick={() => setActive(isOpen ? null : i)}
                      className="text-xs font-label font-semibold text-primary-400 hover:text-primary-300 whitespace-nowrap transition-colors">
                      {isOpen ? 'Hide' : 'View Story'}
                    </button>
                  </div>

                  <p className="mt-5 font-heading font-extrabold text-2xl text-primary-400">
                    {c.result}
                  </p>
                  <p className="mt-1 font-heading font-semibold text-sm text-foreground-950">
                    {c.title}
                  </p>

                  <div
                    className={`mt-4 text-sm text-foreground-600 leading-relaxed ${isOpen ? '' : 'line-clamp-3'}`}>
                    {c.summary}
                  </div>

                  {isOpen && (
                    <>
                      <div className="mt-4 rounded-lg bg-background-200/50 border border-white/5 p-4">
                        <p className="text-xs font-label font-semibold uppercase tracking-wide text-foreground-600">
                          Type of Work
                        </p>
                        <p className="mt-1 text-sm text-foreground-950">
                          {c.type}
                        </p>
                      </div>
                      <blockquote className="mt-4 pt-4 border-t border-white/5">
                        <p className="text-sm text-foreground-700 italic leading-relaxed">
                          &ldquo;{c.quote}&rdquo;
                        </p>
                      </blockquote>
                    </>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
